import template from './clientPreliminaryAssesment.html';

export default {
  template,
};
